<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-hdr"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-right mb-5">
          <v-btn
              class="btn-add-templates"
              @click="addBundle"
          >
            Add Bundle
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="white mx-1 pt-2">
        <v-row class="mt-4 ml-4">
          <v-col cols="3">
            <v-text-field
                label="Name"
                placeholder="Enter the name of the image"
                filled
                v-model="name"
                @input="debounceInput"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="bundleSearch"
              class="elevation-1"
          >
            <template v-slot:item.img_url="{item}">
              <img :src="item.img_url ? url + item.img_url:'' " aspect-ratio="1.7" style="width: 200px; margin-top: 8px" contain/>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_BUNDLE, GET_LIST_BUNDLE_BY_SEARCH} from "@/store/modules/bundle";
import {debounce} from "debounce";


export default {
  name: "Bundle",
  data() {
    return {
      page: "Bundle",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Bundle",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Name", value: "name"},
        {text: "Photo", value: "img_url"},
        {text: "Credit", value: "credit"},
        {text: "Description", value: "description"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      name: '',
      url:''
    }
  },
  computed: {
    ...mapGetters({
      bundleSearch: "bundleSearch",
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    this.params()
  },
  methods: {
    params() {
      let params = {
        keyword: this.name,
      };
      this.$store.dispatch(GET_LIST_BUNDLE_BY_SEARCH, params);
    },

    replaceOrder() {
      this.$router.replace({
        query: {
          keyword: this.name,
        }
      })
    },
    debounceInput: debounce(function (e) {
      this.name = e;
      this.replaceOrder();
      this.params();
    }, 200),
    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_BUNDLE}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_BUNDLE_BY_SEARCH);
        }
      })
    },
    editItem(id) {
      this.$router.push("/template_setting/bundle/edit_bundle/" + id)
    },
    addBundle() {
      this.$router.push("/template_setting/bundle/add_bundle")
    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
</style>